import { CreatePatientInfoDTO } from './domain/models/PatientInfo'
import { PatientRepository } from './domain/repositories/PatientRepository'
import { patientDatasourceAdapter } from './external/patientDatasourceAdapter'
import { patientRepositoryAdapter } from './infra/patientRepositoryAdapter'

export const patientInstance = Patient(
  patientRepositoryAdapter(patientDatasourceAdapter)
)

export default function Patient(patientRepository: PatientRepository) {
  return {
    async getTherapistPatientList(personaId: string) {
      return await patientRepository.getTherapistPatientList(personaId)
    },
    async getOperatorPatientList() {
      return await patientRepository.getOperatorPatientList()
    },
    async getResponsiblePatientList() {
      return await patientRepository.getResponsiblePatientList()
    },
    async ListPatientResponsibles(patientId: string) {
      return await patientRepository.ListPatientResponsibles(patientId)
    },
    async getPatient(id: string) {
      return await patientRepository.getPatient(id)
    },
    async createPatient(data: CreatePatientInfoDTO) {
      await patientRepository.createPatient(data)
    },
    async activatePatient(patientId: string) {
      return await patientRepository.activatePatient(patientId)
    },
    async deactivatePatient(patientId: string) {
      return await patientRepository.deactivatePatient(patientId)
    }
  }
}
